module.exports = __webpack_public_path__ + "img/product_icon_vea.c6698704.png";